import { normalizeAction, getMenuLabel, sortOptionTemplate } from "../toolbar/helpers";
import { getToolbarText } from "../toolbar/buttons";

webix.protoUI({
	name: "ssheet-button",
	$cssName: "button",
	defaults:{
		width: 40
	},
	$init: function(config){
		const arrowCss = config.arrow ? " webix_ssheet_button_menu" : "";
		const iconCss = config.label ? "" : " webix_ssheet_icon_only";
		this.$view.className += " webix_ssheet_button" + arrowCss + iconCss;
		if (config.label || config.icon) {
			const icon = config.icon || config.name;
			let text = config.label || "";
			if (config.arrow) {
				const right = webix.skin.$active.inputSpacing / 2;
				text += "<span class='webix_ssheet_button_icon webix_ssheet_icon_arrow webix_icon wxi-menu-down' style='right:" + right + "px;'></span>";
			}
			config.label = "<span class='webix_ssheet_button_icon webix_ssheet_icon ssi-" + icon + "'></span> " + text;
		}
		if (config.options && !config.popup)
			config.popup = getPopupConfig(config.options, config.ssView);

		if (config.tooltip === undefined) {
			config.tooltip = getToolbarText(config.name);
		}
	}
}, webix.ui.button);


webix.protoUI({
	name: "ssheet-button-icon-top",
	$cssName: "button",
	defaults: {
		width: 70,
		height: 70
	},
	$init: function(config) {
		this.$view.className += " ssheet_button_icon_top";
		if (config.label) {
			const icon = config.icon || config.name || "";
			const text = config.label;
			config.label = "<span class='webix_ssheet_button_icon webix_ssheet_icon ssi-" + icon + "'></span><br/>";
			config.label += "<span class='ssheet_button_icon_top_text'>" + text + "</span>";
			if (config.arrow !== false)
				config.label += "<br/><span class='ssheet_button_icon_top_arrow webix_icon wxi-menu-down'></span>";
		}
		if (config.options && !config.popup)
			config.popup = getPopupConfig(config.options);

		if (config.tooltip === undefined) {
			config.tooltip = getToolbarText(config.name);
		}
	}
}, webix.ui.button);


function getPopupConfig(options, view){
	return {
		view: "ssheet-suggest",
		css: "webix_ssheet_suggest",
		autowidth: true,
		template: function(obj) {
			let html = "";
			if (obj.icon)
				html += "<span class='webix_ssheet_button_icon webix_ssheet_icon ssi-" + obj.icon + "'></span> ";
			
			let text = obj.value || getMenuLabel(obj.id);

			if (obj.id === "sort-sheet-asc" || obj.id === "sort-sheet-desc") {
				text = sortOptionTemplate(obj, view);
			}

			return html + text;
		},
		data: options,
		on:{
			onMenuItemClick: function(id){
				const button = this.config.master;
				if (button) {
					const action = webix.copy(this.getMenuItem(id));
					if (!action.submenu) {
						normalizeAction(action);

						let params = [action];
						const view = webix.$$(button).getTopParentView();
						
						view.callEvent("onCommand", params);
					}
				}
			},
			onBeforeShow: function() {
				this.refresh(); // for the updated template result with current selected cell to actually render
			}
		}
	};
}